import Responsive from './Responsive';
const r = new Responsive();
module.exports = function(str) {
	const template = require('./_remodal_template.html');
	$('.remodal_wrap').each(function(index){
		$(this).find('.remodal_img').append('<a href="" class="remodal_link"></span>');

		let caption = $(this).find('.caption').text();
		let content = $(this).find('img').attr('src');
		let id = 'modal_' + index;
		$(this).find('.remodal_link').attr('href','#' + id);
		// lodash template
		let compiled = _.template(template);
		let data = {
			id: id,
			caption:caption,
			src:content
		};
		let html = compiled(data);

		$('body').append(html);

		let fw = $(this).find('img').prop('naturalWidth') * 0.75;
		$('[data-remodal-id=' + id + ']').width(fw).remodal();
	});
	$('.remodal_img').on('click',function(e){
		if(!r.state()()){
			return false;
		}
		$(this).find('.remodal_link').click();
	});

	$('.remodal_link').click(function(e){
		e.stopImmediatePropagation();
		let id = $(this).attr('href');
		let target = id.replace(/\#/,'');

		if(!r.state()()){
			let src = $('[data-remodal-id='+target+']').find('img').attr('src');
			window.open(src);
			return false;
		}else{
			$('[data-remodal-id='+target+']').remodal().open();
		}

	});
};



// WEBPACK FOOTER //
// ./dev/js/scripts/my_remodal.js